import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { ClientesService } from 'src/app/services/clientes.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-colores',
  templateUrl: './colores.component.html',
  styleUrls: ['./colores.component.scss']
})
export class ColoresComponent implements OnInit {
  enviroment = environment.BASE_URL;

  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;
  respuestaGet:any;

  datosItem;
  itemId;
  data;
  imagenActual;
  colores;

  formulario;
  formularioEdit;
  constructor(private _getColores: CatalogosService, private _agregar: CatalogosService, private _editar:CatalogosService,
    private _update: CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService) { }

  ngOnInit(): void {
    this.getColores();
    this.formulario = {
      'nombre':'',
      imagen: '',
    }

    this.formularioEdit = {
      'nombre':'',
      imagen: '',
    }
  }

  getColores(){
    this._getColores.getColores().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.colores = this.respuestaGet.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarColor(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._agregar.agregarColor(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.dismissAll();
          this.getColores();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }


  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  editarColor(color){
    this.data = {
      'color':color,
    }
    this._editar.editarColor(this.data).subscribe(
      data => {
        this.respuestaEditar= data;
        if(this.respuestaEditar.success){
          this.datosItem = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosItem.nombre;
          this.imagenActual = this.datosItem.imagen;
          this.itemId = color;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateColor(color){

    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('color', color);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._update.updateColor(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getColores();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
